const data: any = {
  func: {
    list: [
      {
        mainTitle: "方案介绍",
        id: "plan_intro",
        subTitleAndDesc: [
          {
            subTitle: "",
            paragraph:
              '<p><span style="font-size:16px">京东联盟是由京东商城推出的面向全网的广告交易平台。 京东商城及其POP商家均是该平台的广告主用户，他们有海量的商品及交易额，由此产生了强劲的推广需求。 通过精准的人群行为定向，智能播放广告，从而提升广告的转化率，提高媒体的收益。</span></p>',
            picture: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX",
            showPicture: false,
          },
        ],
        btns: [{ text: "", link: "" }],
        tableData: [{ columns: [{ title: "", width: 1 }] }],
        figure: [
          {
            picture: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX",
            desc: [{ mainTitle: "", detail: "", logo: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX" }],
          },
        ],
        links: [{ logo: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX", text: "", link: "" }],
      },
      {
        mainTitle: "接入方式",
        id: "access_type",
        subTitleAndDesc: [
          {
            subTitle: "",
            paragraph:
              '<p></p><div class="media-wrap image-wrap"><img src="https://img10.360buyimg.com/imagetools/s554x65_jfs/t1/147296/39/11203/20361/5f8bef12Eaa23270b/085148bc3fb4b634.png!q80" alt=""/></div><p><span style="font-size:16px">宙斯（JOS）是京东各类零售业务提供外部合作伙伴工具和服务的开放平台，例如API、消息推送服务，联盟创建的appkey除了可以在联盟平台（查看联盟接口列表）调用API，也可以在宙斯平台调用联盟接口（查看宙斯接口列表）（SDK请求API方式时推荐使用，支持JAVA/PHP/.NET/Python），二者接入方式不一样，实现功能和数据是一样的。订单行查询接口SDK需使用宙斯SDK。</span></p><p></p><p></p>',
            picture: "",
            showPicture: false,
          },
        ],
        btns: [{ text: "", link: "" }],
        tableData: [{ columns: [{ title: "", width: 1 }] }],
        figure: [
          {
            picture: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX",
            desc: [{ mainTitle: "", detail: "", logo: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX" }],
          },
        ],
        links: [{ logo: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX", text: "", link: "" }],
      },
      {
        mainTitle: "相关接口",
        id: "permission_package",
        subTitleAndDesc: [
          {
            subTitle: "",
            paragraph:
              '<ol><li><span style="font-size:16px">jd.union.open.category.goods.get 接口描述：根据商品的父类目id查询子类目id信息，通常用获取各级类目对应关系，以便将推广商品归类。业务参数parentId、grade都输入0可查询所有一级类目ID，之后再用其作为parentId查询其子类目。</span></li><li><span style="font-size:16px">jd.union.open.order.query 接口描述：查询推广订单及佣金信息，可查询最近90天内下单的订单，会随着订单状态变化同步更新数据。支持按下单时间、完成时间或更新时间查询。建议按更新时间每分钟调用一次，查询最近一分钟的订单更新数据。支持查询subunionid、推广位、PID参数，支持普通推客及工具商推客订单查询。 </span></li><li><span style="font-size:16px"> jd.union.open.goods.query 接口描述：查询商品及优惠券信息，返回的结果可调用转链接口生成单品或二合一推广链接。支持按SKUID、关键词、优惠券基本属性、是否拼购、是否爆款等条件查询，建议不要同时传入SKUID和其他字段，以获得较多的结果。支持按价格、佣金比例、佣金、引单量等维度排序。用优惠券链接调用转链接口时，需传入搜索接口link字段返回的原始优惠券链接，切勿对链接进行任何encode、decode操作，否则将导致转链二合一推广链接时校验失败。</span></li><li><span style="font-size:16px">  jd.union.open.promotion.common.get 接口描述：网站/APP来获取的推广链接，功能同宙斯接口的自定义链接转换、 APP领取代码接口通过商品链接、活动链接获取普通推广链接，支持传入subunionid参数，可用于区分媒体自身的用户ID，该参数可在订单查询接口返回，需向cps-qxsq@jd.com申请权限。</span></li><li><span style="font-size:16px">jd.union.open.goods.promotiongoodsinfo.query 接口描述：通过SKUID查询推广商品的名称、主图、类目、价格、物流、是否自营、30天引单数量等详细信息，支持批量获取。通常用于在媒体侧展示商品详情。</span></li></ol>',
            picture: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX",
            showPicture: false,
          },
        ],
        btns: [{ text: "", link: "" }],
        tableData: [
          {
            columns: [
              { title: "序号", width: 100 },
              { title: "名称", width: 200 },
              { title: "场景介绍", width: 300 },
            ],
          },
        ],
        figure: [
          {
            picture: "//jdc.jd.com/img/920x920?fs=20&t=920*920PX",
            desc: [{ mainTitle: "", detail: "", logo: "//jdc.jd.com/img/196x196?fs=20&t=196*196PX" }],
          },
        ],
        links: [{ logo: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX", text: "", link: "" }],
      },
      {
        mainTitle: "成功案例",
        id: "success_case",
        subTitleAndDesc: [
          {
            subTitle: "",
            paragraph:
              '<p><span style="font-size:16px"><strong>京粉</strong><br/>京东联盟针对无线流量提出一站式营销解决方案-京粉，京粉主要是基于CPS进行社交流量推广，通过京粉可以简单易操作的将微信、QQ、社交群、微博途径的流量，利用分享的形式推广京东平台商品，从而赚取佣金。</span></p><p><span style="font-size:16px"><strong>京粉精选小程序</strong><br/>京粉精选定位为联盟社交达人内容推广平台，将京东联盟的内容达人/MCN网红机构类型推客做垂直化细分，为机构和达人提供优质的选品服务，让机构运营和内容运营者可以线上查看货源，并可以申请样品快递；为机构提供商品维度和达人维度实时查看和历史复盘数据的服务。</span></p><p></p><p></p>',
            picture:
              "//img14.360buyimg.com/imagetools/s114x114_jfs/t1/128094/27/15697/6554/5f8d6fb4Eab276e08/d9a2cb7e67286a57.png!q80",
            showPicture: false,
          },
        ],
        btns: [{ text: "", link: "" }],
        tableData: [{ columns: [{ title: "", width: 1 }] }],
        figure: [
          {
            picture: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX",
            desc: [{ mainTitle: "", detail: "", logo: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX" }],
          },
        ],
        links: [{ logo: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX", text: "", link: "" }],
      },
      {
        mainTitle: "常见问题",
        id: "problems",
        subTitleAndDesc: [
          {
            subTitle: "",
            paragraph:
              '<p><span style="font-size:16px"><strong>一、账户问题列表</strong></span><br/><span style="font-size:16px">1、 个人账户已经审核通过，但京东商城修改了实名信息，导致联盟和商城的实名信息不一致，如何处理？ 如果您修改了商城（或者金融）的实名信息，需要修改联盟的实名信息，使之与商城（或者金融）保持一致，请您联系在线客服咨询，获取操作方法。 </span></p><p><span style="font-size:16px">2、 公司账号公司主体变更如何申请？ 提供联盟ID，变更原因，提交当地工商局管理说明，提交企业变更说明。 并联系在线客服处理。 </span></p><p><span style="font-size:16px">3、公司账户需要上传哪些信息？ 申请人为企业法人时提供企业的营业执照提交审核即可； 申请人和企业法人不一致时需要提供企业法人的身份证正反面的复印件，企业的营业执照，以及企业法人的授权委托书，三项同时上传之后提交审核。 </span></p><p><span style="font-size:16px">4、京东联盟账户被警告/封禁的原因？ 如您在京东联盟的推广经京东联盟确认存在违规或京东联盟不允许的操作方式，京东联盟视情节严重会进行警告或封禁。 </span></p><p><span style="font-size:16px">5、国外网站能不能通过验证？ 如果您的网站没有通过中国工信部的备案，不能在京东联盟后台验证通过。比如美国空间的域名没有工信部备案的，则不可以验证通过。 </span></p><p><span style="font-size:16px">6、联盟个人账户和公司账户的区别？ 个人账户和公司账户的最大区别在于提现时是否需要提供发票给京东联盟； 个人账户提现目前由京东联盟提供代开发票业务，公司账户需根据提现金额开具等额发票。 </span></p><p><span style="font-size:16px">7、如何知道自己的联盟账号被封禁？可以申诉吗？怎么申诉？ 京东联盟通过联盟官方邮箱：cps@jd.com 将邮件发送至联盟会员在京东联盟填写的邮箱。 申诉流程：请按照您的推广方式，准备申诉材料，发邮件到cps@jd.com进行申诉 1.网站推广 申诉材料: （1）网站自身流量 近45天流量来源（搜索引擎、自然流量、购买等）、网站质量数据、推广url、到达页面、推广方式（无线、pc、app、客户端等）、有可能引起流量异常的原因，可截图或录视频。 （2）购买流量 推广平台、购买流量截图及数据统计截图、投放方式、推广位、到达页面、推广链接获取方式及日均生成量级 （3）主要推广平台（PC/无线） 举例： a、网站质量：验证站点信息、收录、排名、日均点击量 b、主要推广哪些页面或者产品 c、主推页面或商品所在的推广者页面或推广方式（比如在页面【aaa.com】推广商品) d、主要推广页面或推广方式的流量来源、具体数据（比如页面【aaa.com】的流量主要来seosem，日均点击在1000） 2.微博、论坛、 申诉材料: 近45天发帖的规模数量，发帖时间，帖子未失效链接举例，后台 所有帖子列表截图。 3.QQ推广 申诉材料: 群数量、群成员数、群列表截图、主推商品、近45天聊天记录截图、推送形式（手动/程序自动推送），如有必要可录制视频尽量还原推广场景。 将申诉材料发送邮件到cps@jd.com ，邮件标题：联盟ID+封禁申诉 </span></p><p><span style="font-size:16px">8、京东联盟企业账户选择商户号（即：京东金融账户）后是否可以更改？ 企业账户可以随时更改商户号。如联盟账户中有待付款的结算单，建议待付款完毕后更改，以免付款失败 </span></p><p><span style="font-size:16px">9、账号重置确认函 个人账号信息重置，填写确认函（个人账号）即可； 企业账号信息重置，填写确认函（企业账号）即可； 从2020年5月13日开始，联盟不再接收个人账号升级为企业的申请，账号类型选择后将不可更改，因此完善信息时候请务必慎重！ </span></p><p><span style="font-size:16px">10、公司账号公司名称变更如何申请？ 提供联盟ID，变更原因，原公司和变更公司的营业执照复印件，以及加盖公章的原公司和变更公司的共同说明。并联系在线客服处理。 </span></p><p><span style="font-size:16px">11、京东联盟账号实名信息与京东账号实名信息不一致，如何处理？ 注册账号为同一账号，则京东联盟实名认证信息会同步该账号在京东金融实名认证信息。如有疑问请发邮件至cps@jd.com 邮箱反馈。 </span></p><p><span style="font-size:16px">12、京东金融企业账户类型提现，转账等是否有条件限制，企业账户是否有钱包账户等级？ 京东金融企业账户类型提现，转账无条件限制，且企业账户不区分一类户，二类户，三类户的京东金融账户等级。 </span></p><p><span style="font-size:16px">13、京东联盟的账户类型与京东金融的账户类型是否要保持一致？ 必须保持一致，即京东联盟账户类型为个人账户类型，则绑定京东金融账户类型必须为个人类型，京东联盟账户类型为企业，绑定京东金融账户类型必须为企业类型 </span></p><p><span style="font-size:16px">14、个人账户已经绑定了京东金融是否可以更改绑定？ 个人账号绑定京东金融账号后，无法解除绑定，请您谨慎操作。 </span></p><p><span style="font-size:16px">15、账号绑定的手机号已经不再使用，无法进行实名认证，如何申请更换？ 请提供不使用的手机号码，您的身份证正反面的照片和您本人的手持身份证拍照，说明更换手机号码原因，发邮件至cps@jd.com的邮箱，收到之后联盟工作人员会为您查询回复。 </span></p><p><span style="font-size:16px">16、原注册京东联盟的账号已经不再使用，如何申请更换？ 京东联盟、京粉APP属于京东账号的一项服务，如果京东账号已经不再使用，则联盟权益及功能也无法继续使用。 若想继续使用联盟产品服务，则可以注册新的京东账号并开通联盟服务。 如果您发现自己的身份信息被原账号占用，则可向CPS邮箱（cps@jd.com），申请重置原账号的联盟信息。 您好，如您确定个人账户不再使用，注销需要按照以下格式回复（注销佣金无法提取，账户无法使用），京东联盟的邮箱：cps@jd.com： 1、联盟ID: 2、申请注销原因： 3、账户中有无正在提现中的金额（如有需要驳回或者提现完成之后才能修改，如果不清楚或无法登陆可咨询联盟在线客服）； 4、附件提供相应的JPG格式的身份证正反面复印扫描件和手持身份证照片（需要清晰能看清字迹）。 工作人员收到之后将会在5个工作日左右尽快为您回复（由于影响佣金结算等，每月15号—27号不进行账号修改与注销，如遇此日期将顺延），谢谢~ 另：企业账户注销需联系人/法人身份证正反面扫描件、手持身份证照片、注销证明、营业执照、授权委托书（如非法人） </span></p><p><span style="font-size:16px">17、一个公司名称对应多个京东联盟企业账户，如何选择商户号（即：京东金融账户）？ 一个公司名称对应多个京东联盟企业账户，同样一个公司可以对应多个商户号。联盟会员可以根据自身需求选择商户号。</span></p><p><span style="font-size:16px"><strong>二、推广/效果 问题列表</strong></span><br/><span style="font-size:16px">1、QQ、微信等推广应选择什么推广方式？ QQ、微信等推广属于聊天工具推广，媒体名称、用户主页地址、登录账号会员请自行填写。该板块升级后，可以支持更为精准的推广渠道选择和信息填写。</span></p><p><span style="font-size:16px">2、效果报表-内容效果数据是哪些订单数据？推广效果如何查看推广数据？ 效果报表-内容效果：联盟会员推广文章或京东站内的推广者所写文章产生的推广效果； 效果报表-推广效果：联盟会员可根据推广内容，推广媒介，以及发布渠道等方式查看推广效果。 </span></p><p></p>',
            picture: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX",
            showPicture: false,
          },
        ],
        btns: [{ text: "", link: "" }],
        tableData: [{ columns: [{ title: "", width: 1 }] }],
        figure: [
          {
            picture: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX",
            desc: [{ mainTitle: "", detail: "", logo: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX" }],
          },
        ],
        links: [{ logo: "//jdc.jd.com/img/200x200?fs=20&t=200*200PX", text: "", link: "" }],
      },
    ],
    navIcon:
      "//img12.360buyimg.com/imagetools/s30x30_jfs/t1/137171/22/12837/511/5f8bf50dE8d007da8/a23f5a360c487b3d.png!q80",
  },
  style: {},
  data: {
    perm_list: {
      type: "remote",
      config: {
        id: 7,
        url: "//joshome.jd.com/perm/list",
        method: "GET",
        headers: null,
        options: null,
        dataName: "perm_pack_list",
        reqParams: { cateId: { title: "分类id", scope: "url", name: "cateId", value: "" } },
        dynamicParams: {},
        filter: "return data;",
        dataRoute: "",
        pathname: "/perm/list",
      },
      data: {
        code: 0,
        success: true,
        data: [
          {
            permPackageId: 581,
            permPackageName: "会员营销基础包",
            permPackageDesc: "会员营销基础包",
            permPackageType: 1,
            permPackageStatus: 0,
            permPackageApproveDesc: null,
          },
          {
            permPackageId: 582,
            permPackageName: "会员营销高级包",
            permPackageDesc: "会员营销高级包",
            permPackageType: 2,
            permPackageStatus: 0,
            permPackageApproveDesc: null,
          },
        ],
      },
      localFilter: "return data;",
    },
  },
  _clstag_: "jdzeus_jdunion_zeus_solution_ability_detail",
};
export default data;
